module.exports = __webpack_public_path__ + "img/logo.83671cd3.svg";